import { defineMessages } from 'react-intl';

/** The work state of a Studio step-2 card (owner request 2026-10-06). */
export const studioCardWorkMessages = defineMessages({
  making: { id: 'app.sml.promote.studio.cardWork.making', defaultMessage: '{count} making' },
  ready: { id: 'app.sml.promote.studio.cardWork.ready', defaultMessage: '{count} ready' },
  failed: { id: 'app.sml.promote.studio.cardWork.failed', defaultMessage: '{count} failed' },
  progress: { id: 'app.sml.promote.studio.cardWork.progress', defaultMessage: 'Making: {percent} %' },
  seeWork: { id: 'app.sml.promote.studio.cardWork.seeWork', defaultMessage: 'See the work' },
  open: { id: 'app.sml.promote.studio.cardWork.open', defaultMessage: 'Open' },
});
